import { Component, Input, TemplateRef } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { TreeWrapperNode } from '../models/tree-wrapper-node.model';

@Component({
    selector: 'tree-node-children',
    templateUrl: './tree-node-children.component.html',
    styleUrls: ['./tree-node-children.component.scss'],
    animations: [
        trigger('animateExpand', [
            state('expanded', style({ height: '*', opacity: 1 })),
            state('collapsed', style({ height: 0, opacity: 0 })),
            transition('collapsed <=> expanded', animate('100ms ease-in-out'))
        ])
    ],
    standalone: false
})
export class TreeNodeChildrenComponent {
  @Input() node: TreeWrapperNode;
  @Input() templates: { treeNodeFullTemplate: TemplateRef<any> };

  trackByNodeId(index: number, childNode: TreeWrapperNode): any {
    return childNode.id;
  }
}

